import { render } from "./CarouselHome.vue?vue&type=template&id=6a808b7c&scoped=true"
import script from "./CarouselHome.vue?vue&type=script&lang=js"
export * from "./CarouselHome.vue?vue&type=script&lang=js"

import "./CarouselHome.vue?vue&type=style&index=0&id=6a808b7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a808b7c"]])

export default __exports__